// extracted by mini-css-extract-plugin
export default {"wrapper":"side-bar-right_wrapper__9EZ1+","header":"side-bar-right_header__qFKZ1","content":"side-bar-right_content__qaVfN"};